module.exports = __webpack_public_path__ + "dde3dd3fc14e24784f73b853b818de19.jpg";